module.exports = __webpack_public_path__ + "img/3-4-1.fed7230c.png";